import { pricingTiers, type Tier } from "@/data/pricing";

export type SizeAnswer = "solo" | "small" | "mid" | "large";
export type LocationAnswer = "one" | "two" | "three-four" | "five-plus";
export type GoalAnswer = "calls" | "competitors" | "expand";

const SIZE_LEVEL: Record<SizeAnswer, number> = { solo: 1, small: 3, mid: 4, large: 6 };
const LOCATION_LEVEL: Record<LocationAnswer, number> = { one: 1, two: 2, "three-four": 4, "five-plus": 5 };
const GOAL_BONUS: Record<GoalAnswer, number> = { calls: 0, competitors: 1, expand: 1 };

export function recommendLevel(size: SizeAnswer, locations: LocationAnswer, goal: GoalAnswer): number {
  const base = Math.max(SIZE_LEVEL[size], LOCATION_LEVEL[locations]);
  return Math.min(6, base + GOAL_BONUS[goal]);
}

export function planSlug(tier: Tier): string {
  return tier.name.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}

export function recommendPlan(size: SizeAnswer, locations: LocationAnswer, goal: GoalAnswer): Tier {
  return pricingTiers[recommendLevel(size, locations, goal) - 1];
}

/** Six key inclusions: keywords, locations, blog posts, backlinks, speed/press, team. */
export function keyInclusions(tier: Tier): string[] {
  const f = tier.features;
  return [f[0], f[2], f[4], f[5], f[6], f[7]];
}
